// extracted by mini-css-extract-plugin
export var buttons = "_4q-0";
export var buttonsActive = "_4q-h";
export var cancelConfirm = "_4q-1";
export var closeButton = "_4q-2";
export var column = "_4q-3";
export var container = "_4q-4";
export var detailHeader = "_4q-6";
export var detailTitle = "_4q-7";
export var detailsContent = "_4q-5";
export var header = "_4q-8";
export var headerWithClose = "_4q-9";
export var icon = "_4q-a";
export var infoIcon = "_4q-c";
export var informationContainer = "_4q-b";
export var sideDrawer = "_4q-d";
export var sideDrawerOpen = "_4q-e";
export var stickyFooter = "_4q-f";
export var typeOption = "_4q-g";